export function getAlertDismissStorageKey(
  message?: string | null,
  expiryDate?: string | null
): string | null {
  if (!message?.trim()) return null;
  const datePart = expiryDate ?? "no-expiry";
  const messagePart = message.trim().slice(0, 80);
  return `alert-dismissed-${datePart}-${messagePart}`;
}
